<template>
  <div class="w-100">
    <div class="w-100 mb-3">
      <div class="row">
        <div class="col-8 no-ws">
          <div class="d-inline-block align-middle mr-3 rounded-circle" style="height: 40px;width: 40px;">
            <img :src="data.avatar" class="img-fit rounded-circle">
          </div>
          <div class="d-inline-block align-middle">
            <p class="body-1-4 mb-0">{{ data.first_name }}</p>
            <star-rating 
              :star-size="16"
              active-color="#FED141"
              :increment="0.1"
              :rating="data.star"
              read-only
              :show-rating="false">    
            </star-rating>
          </div>
        </div>
        <div class="col-4 text-right">
          <p class="body-3-1 mb-0">{{ $formatDate(data.created_at) }}</p>
        </div>
      </div>
    </div>
    <div class="w-100">
      <p class="mb-0 body-2-2 text-16 font-medium d-inline-block align-middle">{{data.message}}</p>
    </div>
    <div class="w-100 mt-3" v-if="data.image.length > 0">
      <div class="row slim-grid-row">
        <div class="col-sm-2 col-4" v-for="(img,img_i) in data.image">
          <div class="w-100" :class="img_i+1 < data.image.length?'pb-3':''">
            <div class="w-100" style="height: 100px;" >
              <img :src="img.image_url" class="img-fit rounded-3 cursor-pointer" @click="setActiveImage(img_i)">
            </div>
          </div>
        </div>
      </div>

      <CoolLightBox 
        :items="data.image" 
        srcName="image_url" 
        :index="active_image"
        @close="active_image = null">
      </CoolLightBox>
    </div>
  </div>
</template>

<script>
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    props:['data'],
    components:{
      CoolLightBox
    },
    data(){
      return{
        active_image: null
      }
    },
    methods:{
      setActiveImage(index){
        this.active_image = index
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/ReviewItem.vue